import React from 'react'
import styles from './MicrositePagination.module.css'
import { ChevronLeft, ChevronRight } from 'lucide-react'

/**
 * MicrositePagination
 *
 * Cursor-based prev/next pagination, matching the cursor pattern
 * used by all list APIs (micrositeGetRedirects, micrositeGetSeoPages,
 * micrositeGetCustomPages, micrositeGetBlogPosts, etc.) — each
 * returns { data, nextCursor }. There's no total count or page
 * number from the API, so this renders as a simple prev/next pair
 * with a history stack of cursors maintained by the parent screen.
 *
 * Usage:
 *   const [cursorStack, setCursorStack] = useState([null]) // null = first page
 *   const currentCursor = cursorStack[cursorStack.length - 1]
 *
 *   // after fetching with currentCursor, store res.response.nextCursor
 *
 *   <MicrositePagination
 *     hasPrev={cursorStack.length > 1}
 *     hasNext={!!nextCursor}
 *     onPrev={() => setCursorStack((s) => s.slice(0, -1))}
 *     onNext={() => setCursorStack((s) => [...s, nextCursor])}
 *     loading={loading}
 *   />
 */
const MicrositePagination = ({
    hasPrev = false,
    hasNext = false,
    onPrev,
    onNext,
    loading = false,
    currentCount,
    label
}) => {
    if (!hasPrev && !hasNext && !label) return null

    return (
        <div className={styles.wrap}>
            <div className={styles.label}>
                {label || (currentCount !== undefined ? `${currentCount} item${currentCount === 1 ? '' : 's'}` : '')}
            </div>

            <div className={styles.controls}>
                <button
                    type="button"
                    className={styles.btn}
                    onClick={onPrev}
                    disabled={!hasPrev || loading}
                >
                    <ChevronLeft size={14} />
                    Previous
                </button>
                <button
                    type="button"
                    className={styles.btn}
                    onClick={onNext}
                    disabled={!hasNext || loading}
                >
                    Next
                    <ChevronRight size={14} />
                </button>
            </div>
        </div>
    )
}

export default MicrositePagination